module.exports = __webpack_public_path__ + "static/media/mountadex-macbook-mountain-hero.ffb185d7.jpg";